<template>
  <el-dialog
    title="修改订单价格"
    :visible.sync="dialogVisible"
    width="600px"
    class="dialog"
    @open="handleOpen"
  >
    <div>
      <el-form :model="form" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="订单原价：">
          {{ data.orderPrice }}元
        </el-form-item>
        <el-form-item label="修改价格：" prop="orderPrice">
          <el-input v-model="form.orderPrice"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitClick" :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { setOrderBasicInfo } from "@/api/mall";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      form: {
        orderPrice: null,
      },
      rules: {
        orderPrice: [
          { required: true, message: "请输入修改后的价格", trigger: "blur" },
          {
            pattern:
              /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输⼊正确的格式,可保留两位⼩数",
            trigger: "blur",
          },
        ],
      },
      btnLoading: false,
    };
  },
  methods: {
    handleOpen() {
      this.form = {
        orderPrice: null,
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    async submitClick() {
      await this.$refs.form.validate();
      this.btnLoading = true;
      const {
        checkmallOrderBasic: { checkmallOrderBasicId },
      } = this.data;
      await this.$axios
        .post(setOrderBasicInfo, {
          checkmallOrderBasicId,
          orderPrice: this.form.orderPrice,
        })
        .finally(() => {
          this.btnLoading = false;
        });
      this.$message.success("修改成功");
      this.dialogVisible = false;
      this.$emit("success");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
